import { getDefaultTrackedProperties } from './utils/getDefaultTrackedProperties.js';
import { create } from 'zustand';

const useAnalyticsStore = create()((set, get) => ({
  providers: [],
  addProvider: (provider) => set((state) => ({
    providers: [
      ...state.providers,
      provider
    ]
  })),
  track: async (event, properties) => {
    const { providers } = get();
    const defaultProps = await getDefaultTrackedProperties();
    const mergedProperties = {
      ...defaultProps,
      ...properties
    };
    await Promise.all(providers.map((provider) => provider.track(event, mergedProperties)));
  },
  identify: (user) => {
    const { providers } = get();
    providers.forEach((provider) => provider.identify(user));
  }
}));

export { useAnalyticsStore };
//# sourceMappingURL=analytics.store.js.map
